import Evaluation, { EvaluationProps } from './Evaluation'
import { SaveQuestionsProvider } from './contexts/SaveQuestions'

const WrapEvaluation = (props: EvaluationProps) => (
  <SaveQuestionsProvider
    onClose={props.onClose}
    containerRef={props.containerRef}
  >
    <Evaluation {...props} />
  </SaveQuestionsProvider>
)

export default WrapEvaluation
